import { render, staticRenderFns } from "./HandleDialogCom.vue?vue&type=template&id=90c959dc&scoped=true"
import script from "./HandleDialogCom.vue?vue&type=script&lang=js"
export * from "./HandleDialogCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c959dc",
  null
  
)

export default component.exports